import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let rota: string = 'login';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
